import { useSyncExternalStore } from 'react';

import { getAppConfigVersion, subscribeAppConfig } from '@/lib/appConfig';

/**
 * Перерисовать экран, когда приедут настройки с сервера.
 *
 * 🔴 ЗАЧЕМ. Настройки приходят запросом, то есть ПОСЛЕ первой отрисовки. Экран,
 * нарисованный до их приезда, остаётся на умолчаниях навсегда — перерисовать его
 * было нечему. На внутренних экранах это не всплывало: туда человек попадает
 * уже после загрузки. Всплыло на главной странице сайта — тумблер выключен на
 * сервере, а страница показывалась как ни в чём не бывало.
 *
 * ⚠️ Нужен ЛЮБОМУ экрану, который читает `isFeatureOn` и может оказаться первым:
 * главная, вход, экран ожидания старта.
 */
export function useAppConfig(): number {
  return useSyncExternalStore(subscribeAppConfig, getAppConfigVersion, getAppConfigVersion);
}
